import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Config from './Config';

const path = window.location.pathname.toLowerCase();
const isConfigPage = path.includes('/config');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isConfigPage ? <Config /> : <App />}
  </React.StrictMode>
);
